<form [formGroup]="organizationForm">
	<div class="card-infos grid-6">
		<mat-form-field floatLabel="always">
			<mat-label translate>add-suborg.org-name</mat-label>
			<input matInput formControlName="orgName" type="text" spellcheck="false" autocomplete="off"
			maxlength="50" required>
			<mat-icon matSuffix class="div-mat-input-icon copo-orange-text-icon" svgIcon="md:edit"></mat-icon>
			<mat-error translate>add-user.required</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<mat-label translate>add-suborg.vat-number</mat-label>
			<input matInput formControlName="vatNumber" type="text" spellcheck="false" autocomplete="off"
			maxlength="50" required>
			<mat-icon matSuffix class="div-mat-input-icon copo-orange-text-icon" svgIcon="md:edit"></mat-icon>
			<mat-error translate>add-user.required</mat-error>
		</mat-form-field>
	</div>
</form>